import React from 'react';
import LabelViewHorizontal from './LabelViewHorizontal';
import LabelView from './LabelView';
import FIcon from "./text/FIcon";
import PropTypes from "prop-types";
import axios from 'axios';
import { API_HOST } from '../consts';
import { get } from 'lodash';

export default class ListData extends React.Component {
  static propTypes = {
    buttons: PropTypes.arrayOf(PropTypes.element),

  };

  state = {
    metadata: {},
  }

  static defaultProps = {
    atualizado_em: '',
    versao: '',
    buttons: []
  };

  mapMetadata(metadata) {
    const mapped = {};
    metadata.forEach((m) => {
      mapped[`${m.model}.${m.name}`] = m.requireness;
    });
    return mapped;
  }

  shouldDisplay(field) {
    const { metadata } = this.state;
    return get(metadata, field) > 0;
  }
  fetchMetadata() {
    this.setState({ fetchingMetadata: true });
    return axios
      .get(`${API_HOST}/params/param?model=item`)
      .then((response) => {
        this.setState({
          metadata: this.mapMetadata(response.data),
          fetchingMetadata: false
        });
      });
  }

  componentDidMount() {
    this.fetchMetadata();
  }

  renderDescription() {
    if (this.props.vertical) {
      return (
        <div className="row">
          {
            this.props.description ? this.props.description.map(data =>
              <LabelView title={data.label} text={data.value} />
            )
              : null
          }
        </div>
      );
    }
    return this.props.description ? this.props.description.map(data =>
      <LabelViewHorizontal key={data.label} title={data.label} text={data.value} />,
    )
      : null;
  }

  render() {
    const {
      atividadeId,
      title,
      small,
      atualizado_em,
      criado_em,
      versao,
      componente_curricular,
      itemEnem
    } = this.props;

    return (
      <div className="list-data">
        <div className="list-data-title">
          <h3 style={{ color: '#453166' }}>{atividadeId} - {title}</h3>
          {componente_curricular && componente_curricular ? (
            <h2 style={{ marginBottom: '0px', fontSize: '14px', fontWeight: '600', marginTop: '8px' }}>Componente Curricular: {componente_curricular && componente_curricular.descricao}</h2>
          ) : (
            <></>
          )}
          {small ? <small className="list-data-text"><p>{small}</p></small> : null}
          <div style={{display: 'flex', width: '100%', alignItems: "center"}}>
            {this.renderDescription()}

            {itemEnem && this.shouldDisplay('item.flagEnem') && (
              <div
                style={{
                  fontWeight: 800,
                  backgroundColor: "#ff5",
                  padding: "4px 6px",
                  width: "fit-content",
                  borderRadius: '8px',
                  marginTop: "8px"
                }}
              >
                ENEM
              </div>
            )}
          </div>
          {
            atualizado_em && versao && (
              <p className="meta-descip mt-2">
                <FIcon icon="clock" type="far" margin="5" />
                {
                  criado_em &&
                  <span className="mr-2 font-weight-normal">Criado em: {criado_em} -</span>
                }
                Última atualização: {atualizado_em}
              </p>
            )
          }
          <div className="text-left">
            {this.props.buttons}
          </div>
        </div>
      </div>
    );
  }
}
